module.exports = {
	footerText: "FAST IN TRANSIT INSURANCE CRM© 2023",
};
